import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

function Counter({ target, suffix = "", testId }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  return (
    <span ref={ref} data-testid={testId} className="font-serif text-5xl sm:text-6xl font-bold text-oro tabular-nums">
      {value}
      {suffix}
    </span>
  );
}

const STATS = [
  { target: 30, suffix: "+", label: "Anni nel vino", testId: "counter-stat-years" },
  { target: 500, suffix: "+", label: "Studenti formati", testId: "counter-stat-students" },
  { target: 16, suffix: "", label: "Edizioni del corso base", testId: "counter-stat-editions" },
  { target: 1, suffix: "", label: "Libro pubblicato", testId: "counter-stat-book" },
];

export default function Counters() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-14">
      {STATS.map((s) => (
        <div key={s.testId} className="text-center">
          <Counter target={s.target} suffix={s.suffix} testId={s.testId} />
          <p className="mt-3 text-sm uppercase tracking-[0.2em] text-panna/60">{s.label}</p>
        </div>
      ))}
    </div>
  );
}
